<template>
  <div>
    <record-list v-show="tabType === 1" @handleShow="handleShow" />
    <record-show v-if="tabType === 2" :rowItem="rowItem" :technicalState="technicalState" @handleShow="handleShow"/>
  </div>
</template>

<script>
import recordList from './list.vue'
import recordShow from './show.vue'
export default {
  components: { recordList,recordShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType=type
      this.rowItem = { ...row }
      this.technicalState = type
    }
  }
}
</script>

<style>
</style>
